import { useAccount } from 'modules/account/hooks/useAccount';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useMenu } from 'modules/common/hooks/useMenu';
import { useNotifications } from 'modules/notifications/hooks/useNotifications';

export const useNotificationsMenuButton = () => {
  const { isLoggingIn } = useAuth();

  const { group } = useAccount();

  const { anchorEl, handleClose, handleOpen, open: isMenuOpened } = useMenu();

  const { notifications: notificationsResponse } = useNotifications({
    skipFetching: true,
    only_unseen: true,
    group,
  });
  const notifications = notificationsResponse.notifications;

  return {
    amount: notifications.length,
    anchorEl,
    handleClose,
    handleOpen,
    isLoading: isLoggingIn,
    isMenuOpened,
  };
};
